<template>
  <div ref="gridList" class="fullHeight">
    <div v-if="viewState === 'loading'">
      <v-col cols="12">
        <v-skeleton-loader
          v-bind="attrs"
          type="table-heading, date-picker-days"
        ></v-skeleton-loader>
      </v-col>
    </div>
    <div ref="gridListMixed" v-if="viewState === 'publications'">
      <mixed-view :source="dataList" :action="next" />
    </div>
    <div class="circle-loader"></div>
    <div v-if="viewState === 'no-publications'" class="emptyPosts">
      <img :src="require('@/assets/img/noPosts.png')" class="emptyContentImg"/>
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'
import MixedView from '@/components/mixed/MixedView'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Mixed',
  data () {
    return {
      attrs: {
        boilerplate: true,
        elevation: 0
      },
      startFirstLoad: false
    }
  },
  props: {
    getterProps: { type: Array },
    actionProps: { type: Object },
    actionParamsProps: { type: String }
  },
  computed: {
    ...mapGetters([this.getterProps]),
    loading () {
      return !this.startFirstLoad || !this.finishFirstLoad
    },
    hasContent () {
      return !_.isEmpty(this.dataList)
    },
    dataList () {
      return this.$store.getters[this.getterProps[0]]
    },
    finishFirstLoad () {
      return (
        _.isEmpty(this.$store.getters[this.getterProps[0]]) ===
        _.isEmpty(this.$store.getters[this.getterProps[1]])
      )
    },
    viewState () {
      let viewState = false
      if (!viewState && this.loading) viewState = 'loading'
      if (!viewState && this.hasContent) viewState = 'publications'
      if (!viewState && !this.hasContent) viewState = 'no-publications'
      return viewState
    }
  },
  components: { 'mixed-view': MixedView },
  beforeMount: function () {
    this.$store.dispatch(this.actionProps.resetAction)
    this.next()
  },
  methods: {
    ...mapActions({ ...this.actionProps }),
    nextFinished () {
      this.startFirstLoad = true
    },
    next () {
      this.$store
        .dispatch(this.actionProps.mainAction, this.actionParamsProps)
        .then(this.nextFinished)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MixedView/index.vue